<template>
  <v-container fluid class="hkiarace pa-0">
    <v-navigation-drawer permanent
                         expand-on-hover>
      <v-list dense>
        <v-list-item :to="{name: 'hkiarace-company'}" v-if="$hasPermission('hkiarace.company')" link>
          <v-list-item-icon>
            <v-icon>mdi-domain</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.company') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-event'}" v-if="$hasPermission('hkiarace.list_event')" link>
          <v-list-item-icon>
            <v-icon>mdi-calendar-text</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.event') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-promotion'}" v-if="$hasPermission('hkiarace.promotion')" link>
          <v-list-item-icon>
            <v-icon>mdi-sale</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.promotion') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-corporate-vendor'}" v-if="$hasPermission('hkiarace.corporate_vendor')" link>
          <v-list-item-icon>
            <v-icon>mdi-store</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.corporate_vendor') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-email-template'}" v-if="$hasPermission('hkiarace.email_templates')" link>
          <v-list-item-icon>
            <v-icon>mdi-email-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.email_template') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-survey'}" v-if="$hasPermission('hkiarace.survey')" link>
          <v-list-item-icon>
            <v-icon>mdi-playlist-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_survey.title') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-check-in'}" v-if="$hasPermission('hkiarace.check_in')" link>
          <v-list-item-icon>
            <v-icon>mdi-account-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.check_in') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-redeem-welcome-gift'}" v-if="$hasPermission('hkiarace.check_in')" link>
          <v-list-item-icon>
            <v-icon>mdi-gift-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_redeem_welcome_gift.title') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'hkiarace-report'}" v-if="$hasPermission('hkiarace.reports')" link>
          <v-list-item-icon>
            <v-icon>mdi-file-find-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('admin_hkiarace.report') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <router-view class="hkiarace-admin-main"></router-view>
<!--    <div class="hkiarace-admin-nav">-->
<!--      <router-link :to="{name: 'hkiarace-company'}" v-if="$hasPermission('hkiarace.company')">{{ $t('admin_hkiarace.company') }}</router-link>-->
<!--      &lt;!&ndash;            <router-link :to="{name: 'hkiarace-user'}" v-if="isAdmin">{{$t('admin_hkiarace.user')}}</router-link>&ndash;&gt;-->
<!--      &lt;!&ndash;            <router-link :to="{name: 'operator'}" v-if="isAdmin">{{$t('admin_hkiarace.operator')}}</router-link>&ndash;&gt;-->
<!--      &lt;!&ndash;            <router-link :to="{name: 'hkiarace-event-category'}" v-if="isAdmin">{{$t('admin_hkiarace.event_category')}}</router-link>&ndash;&gt;-->
<!--      <router-link :to="{name: 'hkiarace-event'}" v-if="$hasPermission('hkiarace.list_event')">{{ $t('admin_hkiarace.event') }}</router-link>-->
<!--      <router-link :to="{name: 'hkiarace-promotion'}" v-if="$hasPermission('hkiarace.promotion')">{{ $t('admin_hkiarace.promotion') }}</router-link>-->
<!--      <router-link :to="{name: 'hkiarace-email-template'}" v-if="$hasPermission('hkiarace.email_templates')">{{ $t('admin_hkiarace.email_template') }}</router-link>-->
<!--      <router-link :to="{name: 'hkiarace-survey'}" v-if="$hasPermission('hkiarace.survey')">{{ $t('admin_survey.title') }}</router-link>-->
<!--      &lt;!&ndash;            <router-link :to="{name: 'hkiarace-home-page'}" v-if="$hasPermission('hkiarace.home_page')">{{$t('admin_hkiarace.home_page')}}</router-link>&ndash;&gt;-->
<!--      <router-link :to="{name: 'hkiarace-check-in'}" v-if="$hasPermission('hkiarace.check_in')">{{ $t('admin_hkiarace.check_in') }}</router-link>-->
<!--      <router-link :to="{name: 'hkiarace-report'}" v-if="$hasPermission('hkiarace.reports')">{{ $t('admin_hkiarace.report') }}</router-link>-->
<!--    </div>-->

  </v-container>
</template>

<script>
export default {
  name: 'Event',
  components: {},
  data() {
    return {
      tabIndex: 0,
      selectedEventId: null,
      selectedSessionId: null,
    };
  },
  mounted() {
    this.selectedEventId = this.$route.query.e;
    this.selectedSessionId = this.$route.query.s;

    var v = this;
    setTimeout(function () {
      v.tabIndex = parseInt(v.$route.query.t || "0");
    }, 50)
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.type == 369;
    },
  },
  methods: {
    updateRoute(override) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          t: this.tabIndex,
          e: this.selectedEventId,
          s: this.selectedSessionId,
          ...override,
        },
      })
    },
    tabChanged(tabIndex) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {...this.$route.query, t: tabIndex}
      })
    },
  },
}
</script>

<style lang="less">
.hkiarace {
  height: 100%;
  display: flex;

  .hkiarace-admin-nav {
    width: 20%;
    height: 100%;
    overflow-y: auto;

    display: flex;
    flex-direction: column;

    border-right: 1px solid lightgrey;

    a {
      font-size: 1.5em;
      font-weight: bold;
      text-decoration: none;
      // margin-left: 30px;
      margin: 10px 0;
      color: #a4a4a4;

      &.router-link-active {
        color: #62cbd0 !important;
        font-weight: bolder;
      }
    }

  }

  .hkiarace-admin-main {
    overflow: scroll;

    /*width: 80%;*/
    /*height: 100%;*/
    /*overflow-y: auto;*/
    /*padding-top: 10px;*/
    /*padding-bottom: 10px;*/
  }
}
</style>
